
import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Plus } from 'lucide-react';
import { ClubForm } from '@/components/shared/ClubForm';
import { ClubCard } from './ClubCard';
import { ClubDeleteDialog } from './ClubDeleteDialog';
import { useClubManagement } from '@/hooks/useClubManagement';

export const ClubList = () => {
  const {
    clubs,
    loading,
    isDialogOpen,
    editingClub,
    clubName,
    clubWebsite,
    clubLocation,
    clubProfilePicture,
    clubSport,
    isSubmitting,
    expandedClubs,
    deleteDialogOpen,
    clubToDelete,
    isDeleting,
    setClubName,
    setClubWebsite,
    setClubLocation,
    setClubProfilePicture,
    setClubSport,
    handleSubmit,
    handleEdit,
    handleDeleteClick,
    handleConfirmDelete,
    handleDialogClose,
    handleDeleteDialogClose,
    toggleClubExpansion,
    setIsDialogOpen
  } = useClubManagement();

  if (loading) {
    return <div>Loading clubs...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Clubs</h3>
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add Club
            </Button>
          </DialogTrigger>
          <ClubForm
            isOpen={isDialogOpen}
            onOpenChange={handleDialogClose}
            onSubmit={handleSubmit}
            clubName={clubName}
            setClubName={setClubName}
            clubLocation={clubLocation}
            setClubLocation={setClubLocation}
            clubWebsite={clubWebsite}
            setClubWebsite={setClubWebsite}
            clubProfilePicture={clubProfilePicture}
            setClubProfilePicture={setClubProfilePicture}
            clubSport={clubSport}
            setClubSport={setClubSport}
            isSubmitting={isSubmitting}
            isEditing={!!editingClub}
          />
        </Dialog>
      </div>

      <div className="space-y-2">
        {clubs.map((club) => (
          <ClubCard
            key={club.id}
            club={{
              ...club,
              website: club.website || '',
              location: club.location || '',
              sport: club.sport || 'Volleyball',
              profile_picture_url: club.profile_picture_url || ''
            }}
            isExpanded={expandedClubs.has(club.id)}
            onToggleExpansion={() => toggleClubExpansion(club.id)}
            onEdit={() => handleEdit(club)}
            onDelete={() => handleDeleteClick(club)}
            isDeleting={isDeleting}
          />
        ))}
      </div>

      <ClubDeleteDialog
        isOpen={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        onConfirm={handleConfirmDelete}
        clubName={clubToDelete?.name || ''}
        isDeleting={isDeleting}
      />
    </div>
  );
};
